module.exports = __webpack_public_path__ + "img/whatsapp.597148f9.svg";